/**
 * CandlestickBuild — one of 5 cockpit loader variants.
 * Ported from landing/components/cockpit/loaders/CandlestickBuild.tsx.
 */

const BAR_HEIGHTS = [35, 58, 42, 71, 55, 63, 38, 80, 48, 67, 52, 75, 44, 60, 69, 46, 73, 50, 65, 56];
const TOTAL_BARS = BAR_HEIGHTS.length;

interface Props {
  progress: number; // 0-100
}

export default function CandlestickBuild({ progress }: Props) {
  const activeBars = Math.round((progress / 100) * TOTAL_BARS);

  return (
    <div className="flex flex-col items-center justify-center h-full gap-8">
      <div className="flex items-end gap-[3px] h-40 sm:h-52">
        {BAR_HEIGHTS.map((height, i) => {
          const isActive = i < activeBars;
          const isLatest = i === activeBars - 1;
          return (
            <div
              key={i}
              className="w-2.5 sm:w-3 transition-all duration-150 ease-out"
              style={{
                height: isActive ? `${height}%` : '2px',
                background: isActive
                  ? isLatest
                    ? 'var(--color-orange)'
                    : 'oklch(from var(--color-orange) l c h / 0.6)'
                  : 'var(--color-surface-muted)',
                boxShadow: isLatest ? '0 0 8px oklch(from var(--color-orange) l c h / 0.4)' : 'none',
              }}
            />
          );
        })}
      </div>
      <div className="font-mono text-2xl font-bold text-txt-primary tabular-nums">
        {Math.round((activeBars / TOTAL_BARS) * 100)}%
      </div>
      <div className="font-mono text-xs tracking-[0.2em] text-txt-tertiary">
        Credia.pro
      </div>
    </div>
  );
}
